// import memberPortalStore from './src/store'
const store = () => import(/* webpackChunkName: 'member-portal-store' */ './src/store')

const MemberPortalInvoices = () => import(/* webpackChunkNmae: 'member-portal' */ './src/views/Invoices')
const MemberPortalSomnambulistSettings = () => import(/* webpackChunkNmae: 'system-settings' */ './src/views/SomnambulistOrders/SettingsForm/index.vue')
const MemberPortalMain = () => import(/* webpackChunkName: 'member-portal' */ './src/member-portal')

const CircumspectisTokens = () => import(/*  webpackChunkName: 'circumspectis-tokens' */ './src/views/SomnambulistOrders/circumspectis-tokens.js')
  .then(module => module.default)

const install = function(Vue, options) {
  if (options.lazyStore === undefined || options.lazyStore === false) {
    if (!options.store) {
      throw new Error('Please register the Member Portal Plugin by passing a Vuex Store')
    }
    options.store.registerModule('memberPortal', store, { preserveState: options.store.state.memberPortal !== undefined })
  }
  options.callbackRegistry.register('VueJSFormTokens', CircumspectisTokens)
}

export default { MemberPortalMain, MemberPortalInvoices, MemberPortalSomnambulistSettings, install, store }
